import { useQuery } from '@tanstack/react-query';

import { cableLinesApi } from '../api/cableLinesApi';
import type { CableLineTypeRef } from '../types';

export const cableMenuQueryKey = ['menu', 'cable', 'types'] as const;

interface UseCableMenuOptions {
  enabled?: boolean;
}

export function useCableMenu(options?: UseCableMenuOptions) {
  return useQuery<CableLineTypeRef[], Error>({
    queryKey: cableMenuQueryKey,
    queryFn: () => cableLinesApi.types(),
    enabled: options?.enabled ?? true,
    staleTime: 60_000,
    gcTime: 5 * 60_000,
    refetchOnWindowFocus: false,
  });
}
